import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MessageService } from '../../../services/message.service';
import { MasterService } from '../../../services/master.service';
import { StoreService } from '../../../services/store.service';
import * as words from '../../../services/language'

import { Stat } from 'src/app/models/stat.model';

@Component({
    selector: 'recency-chart',
    templateUrl: './recency-chart.component.html',
    styleUrls: ['./recency-chart.component.scss'],
    standalone: false
})
export class RecencyChartComponent implements OnInit, OnChanges {

    /** Threshold to determine if the recency percent of the last thirty days is acceptable. */
    private RECENCY_PERCENT_SUCCESS: number = 0.92

    /** Threshold to determine if the recency percent of the last thirty days needs investigation. */
    private RECENCY_PERCENT_WARNING: number = 0.82
    
    // Currently selected language
    @Input() language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'
    
    // Word replacements for each language.
    @Input() words: Object = words.language

    /** */
    @Input() latest: Stat | null = null

    /** Percent of active accounts that have made a recent payment. */
    protected percent: number = 0

    /** Options to send to the cahrt to determine how it will render. */
    protected options = {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: false,
                text: ''
            }
        }
    }

    /** */
    protected stats = null;
    
    // Indicates whether the data is currently loading.
    protected loading: boolean = false

    constructor(private master: MasterService, private ms: MessageService, private store: StoreService) { }

    ngOnInit() {
        
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return
        }

        const first = Object.values(changes).some(c => c.isFirstChange())
        if (first) {
            return
        }
        
        if (changes.latest) {
            this.construct()
        }
    }

    /**
     * Based on the latest stats construct the stat data for us in the chart.
     */
    private construct = () => {
        if (!this.latest) {
            return
        }

        const within30Days = this.latest.recent1to15 + this.latest.recent16to30

        this.percent = 0
        if (this.latest.accounts > 0) {
            this.percent = (within30Days / this.latest.accounts)
        }

        this.stats = {
            labels: ['1 to 15', '16 to 30', '31 to 60', '61 to 90', '91 and over'],
            datasets: [{
                axis: 'y',
                label: null,
                data: [
                    this.latest.recent1to15,
                    this.latest.recent16to30,
                    this.latest.recent31to60,
                    this.latest.recent61to90,
                    this.latest.recent91AndOver
                ],
                backgroundColor: [
                    'rgba(66, 210, 157, 0.2)',
                    'rgba(66, 210, 157, 0.4)',
                    'rgba(66, 210, 157, 0.6)',
                    'rgba(66, 210, 157, 0.8)',
                    'rgba(66, 210, 157, 1)'
                ],
                borderColor: [
                    'rgba(66, 210, 157, 0.0)',
                    'rgba(66, 210, 157, 0.2)',
                    'rgba(66, 210, 157, 0.4)',
                    'rgba(66, 210, 157, 0.6)',
                    'rgba(66, 210, 157, 0.8)'
                ],
                borderWidth: 1
            }]
        }
    }

    /**
     * Based on the current recency percent return a 
     * badge color to use for the percent display.
     */
    protected level = (): string => {
        if (!this.percent) {
            return 'secondary'
        }

        if (this.percent >= this.RECENCY_PERCENT_SUCCESS) {
            return 'success'
        }

        if (this.percent >= this.RECENCY_PERCENT_WARNING) {
            return 'warning'
        }

        return 'danger'
    }
}
